import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

/**
 * Determines if WES Ask Coursera should be displayed based on the current pathname.
 * Used across WES applications (teams-v2, ent-website, enterprise-admin-account).
 *
 * @param pathname - Current URL pathname from router
 * @returns boolean - true if coach should be shown
 */

export const shouldShowWESAskCoursera = (pathname: string): boolean => {
  const coachEnabled = EnterpriseExperiments.get('enableWESCoach');
  const isV2 = EnterpriseExperiments.get('enableWESCoachV2');
  const coachEnabledPaths = isV2
    ? ['/purchase/account', '/business/teams', '/business']
    : ['/purchase/account', '/purchase/billing', '/business/teams'];

  return Boolean(coachEnabled && coachEnabledPaths.some((path) => pathname.includes(path)));
};
